const PREFIX = "pl-bill-separator";

export const PL_BILL_SEPARATOR_TEST_IDS = {
    SEPARATOR: `${PREFIX}-container`,
};
